import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import Controls from './controls/Controls'
import Notification from './Notification'
import { Form, useForm } from './useForm'
import { useDispatch, useSelector } from 'react-redux'
import {
  searchAttendanceAction,
  updateAttendanceAction,
} from '../actions/hrActions'
import { UPDATE_ATTENDANCE_RESET } from '../constants/hrConstants'

const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const initialValues = {
  status: '',
}

const UpdateAttendance = ({ setOpenPopup, attendanceForEdit, date }) => {
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const classes = useStyles()
  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('status' in fieldValues)
      temp.status =
        fieldValues.status.length !== 0 ? '' : 'This field is required'
    setErrors({
      ...temp,
    })
    if (fieldValues === values) return Object.values(temp).every((x) => x == '')
  }

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValues, true, validate)

  useEffect(() => {
    if (attendanceForEdit != null) {
      setValues({
        ...attendanceForEdit,
      })
      console.log(attendanceForEdit)
    }
  }, [attendanceForEdit])

  const dispatch = useDispatch()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (validate()) {
      dispatch(updateAttendanceAction(attendanceForEdit._id, values.status))
    }
  }

  const updateAttendance = useSelector((state) => state.updateAttendance)
  const { loading, error, updAttendance } = updateAttendance

  useEffect(() => {
    dispatch({ type: UPDATE_ATTENDANCE_RESET })
    if (updAttendance) {
      setNotify({
        isOpen: true,
        message: updAttendance.msg,
        type: 'success',
      })
      setTimeout(() => {
        setOpenPopup(false)
        dispatch(searchAttendanceAction(date))
      }, 1000)
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        type: 'error',
      })
    }
  }, [dispatch, updAttendance, error])

  return (
    <>
      <Form autoComplete='off' onSubmit={handleSubmit}>
        <Controls.Select
          label='Status *'
          name='status'
          value={values.status}
          onChange={handleInputChange}
          error={errors.status}
          options={[
            { id: 'Approved', title: 'Approved' },
            { id: 'Rejected', title: 'Rejected' },
          ]}
        />
        <Controls.Button
          type='submit'
          fullWidth
          text='submit'
          className={classes.submit}
          loading={loading}
        />
      </Form>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  )
}

export default UpdateAttendance
